import { memo, useCallback, useMemo } from 'react'
import SelectBox from '~components/ui/text-input/select-box'
import { GroupItem } from '~containers/app/ask-a-vet/types'
import { getGroupItemDisplayValue } from '~containers/app/ask-a-vet/utils'

interface ExtraSelectBoxProps {
  root: GroupItem
  options: Omit<GroupItem, 'extra_component' | 'datafield'>[]
  datafield: string
  placeholder: string
  onSelect: (triggeredItem: GroupItem & { datafield: string }) => void
}
const ExtraSelectBox = memo(
  ({ root, options, datafield, placeholder, onSelect }: ExtraSelectBoxProps) => {
    const value = useMemo(() => root[datafield as keyof GroupItem], [datafield, root])
    const selectedItem = useMemo(
      () => options.find(option => option.value === value),
      [options, value]
    )

    const displayValue = useMemo(
      () => (selectedItem ? getGroupItemDisplayValue(selectedItem) : undefined),
      [selectedItem]
    )

    const _onSelect = useCallback(
      (_selectedItem: GroupItem) => {
        onSelect({
          ..._selectedItem,
          datafield: _selectedItem.datafield || datafield,
        })
      },
      [datafield, onSelect]
    )

    return (
      <SelectBox className="w-full mt-4">
        <SelectBox.Input
          value={displayValue}
          placeholder={placeholder}
          disabled={false}
          onClick={() => {
            if (selectedItem) {
              _onSelect(selectedItem)
            }
          }}
          color="background"
        />
      </SelectBox>
    )
  }
)

ExtraSelectBox.displayName = 'ExtraSelectBox'

export default ExtraSelectBox
